export * from "../overrides/toast";

// soon to be depricated.
import { Toast } from "../overrides/toast";

export default Toast;
